import { render, staticRenderFns } from "./FlipBookList.vue?vue&type=template&id=2d9be41a&"
import script from "./FlipBookList.vue?vue&type=script&lang=js&"
export * from "./FlipBookList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports